/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
} from './FactorMethod';

/**
 * 
 * @export
 * @interface PasswordMethodOptions
 */
export interface PasswordMethodOptions {
    /**
     * 
     * @type {FactorMethod}
     * @memberof PasswordMethodOptions
     */
    method: FactorMethod;
}

/**
 * Check if a given object implements the PasswordMethodOptions interface.
 */
export function instanceOfPasswordMethodOptions(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "method" in value;

    return isInstance;
}

export function PasswordMethodOptionsFromJSON(json: any): PasswordMethodOptions {
    return PasswordMethodOptionsFromJSONTyped(json, false);
}

export function PasswordMethodOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordMethodOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'method': FactorMethodFromJSON(json['method']),
    };
}

export function PasswordMethodOptionsToJSON(value?: PasswordMethodOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'method': FactorMethodToJSON(value.method),
    };
}

